(function() {
    'use strict';

    angular
        .module('app.categorias')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/categorias',
                config: {
                    templateUrl: 'app/categorias/list.html',
                    controller: 'categorias.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-categoria/:id?',
                config: {
                    templateUrl: 'app/categorias/edit.html',
                    controller: 'categorias.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
